import { Component, OnInit, HostListener } from '@angular/core';
import { ConnectRestService } from '../services/connect-rest.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AppComponent } from '../app.component';
import { AppUtilityService } from '../common/app-utility.service';
import { environment } from "src/environments/environment.prod"


declare var $: any;

@Component({
  selector: 'app-company-details',
  templateUrl: './multiple-company.component.html',
  styleUrls: ['./multiple-company.component.scss']
})
export class MultipleCompanyComponent implements OnInit {

  MultipleCompanyDetails: FormGroup
  CompanyList: any;
  

  constructor(
    private connect: ConnectRestService,
    private formBuilder: FormBuilder,
    public router: Router,
    public appComp: AppComponent,
    private activatedRoute: ActivatedRoute,
    private AppUtility: AppUtilityService) {
    //used to prevent back button --- added by Sonny
    sessionStorage.currentPage = window.location.href;
  }


  ngOnInit() {
    
    this.requestCompanyData();

    this.MultipleCompanyDetails = this.formBuilder.group({
     CompanyList:['',Validators.required] 
      // CompanyList: this.formBuilder.group({
      //   BusinessName: [''],
      //   BusinessRegNo: [''],
      //   BusinessType: [''],
      //   ConnectedParties: this.formBuilder.group({
      //     NRIC: [''],
      //     Name: ['']
      //   })
      // })
    });

    
  }

  async requestCompanyData(){
     const RequestID = 'R0014';
     var requestData :any  = await this.connect.connectRest({}, RequestID, '')

  this.CompanyList = requestData.CompanyList
    }
  

  onSubmit() {

  this.updateMethod(this.MultipleCompanyDetails.value);
  
  this.MultipleCompanyDetails.patchValue({
    CompanyList: {
      BusinessName: this.CompanyList.BusinessName,
      BusinessRegNo: this.CompanyList.BusinessRegNo,
      BusinessType: this.CompanyList.BusinessType
    }
  })

  }

  public async updateMethod(data) {
    const RequestID = 'S0014';
    const requestData = await this.connect.connectRest(data, RequestID, '')
  if (requestData.Status === 'Success') {
    this.router.navigate(['/company-details-info']);
     }
  }

}
